import React, { useEffect, useState } from "react";

import "../styles/QuizzesResults.css";

const QuizzesResults = () => {
  const [quizzes, setQuizzes] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/myprofile`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        const isQuizzes = data.msg.map((quiz) => quiz.quizzes).flat();
        setQuizzes(isQuizzes);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  return (
    <section className="quizzes-results">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="quizzes-results-content">
              <h3>
                Quizzes
                <span>Results</span>
              </h3>
              <div className="quizzes-results-content-card">
                <div className="quizzes-results-content-card-header">
                  <ul>
                    <li>Quizzes</li>
                    <li>Date</li>
                    <li>Score</li>
                  </ul>
                </div>
                <div className="quizzes-results-content-card-body">
                  {quizzes?.map((item) => (
                    <div
                      className="quizzes-results-content-card-body-item"
                      key={item._id}
                    >
                      <ul>
                        <li>{item.name}</li>
                        <li>
                          {new Date(item.date).toLocaleDateString("en-US")}
                        </li>
                        <li> {item.score}/5</li>
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuizzesResults;
